import watchEnableGuestWebSaga from './enableGuestWebSaga';
import watchEnableReservationsSaga from './enableReservatonsSaga';
import watchFetchCountriesSaga from './fetchCountriesSaga';
import watchFetchPlaceSaga from './fetchPlaceSaga';
import watchFetchPlaceStateSaga from './fetchPlaceStateSaga';
import watchInitializePlaceSaga from './initializePlaceSaga';
import watchUpdatePlaceSaga from './updatePlaceSaga';

const sagas = [
  watchFetchPlaceStateSaga(),
  watchInitializePlaceSaga(),
  watchFetchCountriesSaga(),
  watchFetchPlaceSaga(),
  watchUpdatePlaceSaga(),
  watchEnableReservationsSaga(),
  watchEnableGuestWebSaga(),
];

export default sagas;
